import { render, staticRenderFns } from "./WienJunior.vue?vue&type=template&id=7cbd3582&"
import script from "./WienJunior.vue?vue&type=script&lang=js&"
export * from "./WienJunior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports